<template>
  <v-form ref="form" style="width: 100%;">
    <v-row>
        <template v-for="(section, i) in sections">
          <template v-if="section.section">
            <v-list-item :key="`section-title-${i}`">
              <v-list-item-content class="text-h6">
                {{ section.section }}
              </v-list-item-content>
            </v-list-item>

            <v-divider
              :key="`section-divider-${i}`"
              class="mb-3 px-4 section--divider"
              light
            ></v-divider>
          </template>

          <template v-for="field in section.fields">

            <div
              :key="`linebreak-${field.sequence}`"
              v-if="(field.config || {}).inline !== 'true'"
              class="linebreak"
            ></div>
            <Field
              :ref="`field-${field.alias}`"
              :key="`${field.sequence}-${refresh}`"
              :eventBus="eventBus"
              :expressionInterpreter="expressionInterpreter.interpreter(field.alias)"
              :label="field.name"
              :required="field.required"
              :alias="field.alias"
              :type="field.type.name"
              :config="field.config"
              :params="field.params"
              :dependency="field.dependency"
              :disabled="lock"
              :sections="sections"
              :disableOutlined="field.disableOutlined"
              :prependIcon="field.prependIcon"
            ></Field>
          </template>
        </template>
    </v-row>
  </v-form>
</template>

<script>
import Field, { FIELD_TYPES, EXTENDED_FIELD_TYPES } from './Field.vue';
import FormExpressionInterpreter from './form-expression-interpreter';

const INPUT_TYPES = Object.values(FIELD_TYPES)
  .concat( // extend valid input types with custom extended field types
    Object.values(EXTENDED_FIELD_TYPES)
      .map((extendedFieldTypeEntry) => extendedFieldTypeEntry[1]),
  );

export default {
  props: {
    id: String,
    data: {
      type: Object,
      required: true,
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    submitVisible: {
      type: Boolean,
      default: () => true,
    },
    profileViewForm: {
      type: Boolean,
      default: () => false,
    },
    showButtons: {
      type: Boolean,
      default: () => true,
    },
  },
  components: {
    Field,
  },
  data({ id, data }) {
    return {
      sections: data.properties.reduce((tot, curr) => {
        const currSection = tot.length ? tot[tot.length - 1] : null;
        if (typeof (curr.config || {}).section === 'string') {
          // field section configured
          if (currSection != null && currSection.section === curr.config.section) {
            currSection.fields.push(curr);
          } else {
            tot.push({ section: curr.config.section, fields: [curr] });
          }
        } else if (currSection != null && currSection.section == null) {
          currSection.fields.push(curr);
        } else {
          tot.push({ fields: [curr] });
        }
        return tot;
      }, []),
      eventBus: this.$events.create(`form-${id}`),
      expressionInterpreter: new FormExpressionInterpreter({
        staticContextFields: {
          element: data,
          user: this.$store.getters['session/user'],
        },
        getFieldsCtx: this.getFieldsCtx,
      }),
      btnDisabled: true,
      elementForInsert: [],
      refresh: false,
      show: true,
    };
  },
  computed: {
    isDesktop() {
      const desktop = window.matchMedia('screen and (min-width: 960px)');
      return desktop.matches;
    },
  },
  watch: {
    btnDisabled(newVal, oldVal) {
      if (!newVal && oldVal) {
        // Cuando btnDisabled pasa de true a false, ejecuta submit
        this.submit('Buscar');
      }
    },
  },
  methods: {
    refreshRange() {
      this.refresh = !this.refresh;
    },
    refreshShow() {
      this.show = true;
    },
    clearFormData() {
      this.show = false;

      // Obtenemos todos los botones con el icono de limpiar y lanzamos su evento click()
      const btnsClears = document.getElementsByClassName('v-input__icon--clear');
      for (let i = 0; i < btnsClears.length; i += 1) {
        const btn = btnsClears[i];
        const btnClear = btn.getElementsByTagName('button');
        if (btnClear && btnClear[0].click) {
          btnClear[0].click();
        }
      }
      this.refreshRange();
      this.btnDisabled = true;
    },
    getFormData() {
      const { fieldsContext } = this.expressionInterpreter;
      const items = Object.entries(fieldsContext); // eslint-disable-line
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== '')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFormDataWithDeleted() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFieldsCtx() {
      const $form = this.$children[0];
      const inputChildren = $form.$children
        .filter((child) => INPUT_TYPES.includes(child.component));
      return inputChildren.reduce((tot, curr) => {
        // eslint-disable-next-line no-param-reassign
        tot[curr.alias] = curr.fieldValue;
        return tot;
      }, {});
    },
    validate() {
      return this.$refs.form.validate();
    },
    validationLdap(ldap) {
      let valid = true;
      if (ldap.length > 0
        && ldap[0].rama === 'sspa'
        && ldap[0].tipo === 'externo'
      ) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.sspaext'),
          type: 'warning',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
          router: '/element/r/AE8358F7C84601FB9A1B000C29B08512',
          routerTitle: 'Alta VPN para usuarios externos',
        });
        valid = false;
      } else if (ldap.length > 0
        && ldap[0].rama === 'sspa'
        && ldap[0].tipo === 'genérico') {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.sspagen'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } else if (ldap.length > 0
      && ldap[0].rama !== 'sas'
      && ldap[0].rama !== 'sspa'
      && ldap[0].rama !== 'FIBAO') {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.notsassspafibao'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } else if (ldap.length > 0
      && ldap[0].rama === 'FIBAO') {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.sspaext'),
          type: 'warning',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
          router: '/element/r/AE8358F7C84601FB9A1B000C29B08512',
          routerTitle: 'Alta VPN para usuarios externos',
        });
      } else if (ldap.length === 0) {
        valid = false;
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.ldap.empty'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
          router: '/profile/edit',
          routerTitle: 'información de perfil',
        });
      }
      return valid;
    },
    async submit(submitBtn) {
      const { form } = this.$refs;
      const formData = this.getFormData();

      if (formData.ldapSubmit && !this.validationLdap(formData.ldapSubmit)) {
        return false;
      }
      if (!form.validate()) {
        this.$nextTick(() => {
          const domRect = document.querySelector('.v-input.error--text').getBoundingClientRect();
          window.scrollTo(
            domRect.left + document.documentElement.scrollLeft,
            // 74 = 64 toolbarheight + 10 margi
            domRect.top + document.documentElement.scrollTop - 74,
          );
        });
        return false;
      }

      const suscriptorsListLocalStorage = localStorage.getItem('suscriptorsList');
      if (suscriptorsListLocalStorage && suscriptorsListLocalStorage.length > 0) {
        const suscriptorsList = JSON.parse(suscriptorsListLocalStorage);
        if (suscriptorsList && suscriptorsList.length > 0) {
          let suscriptorsListAll = '';
          let suscriptorsListName = '';
          suscriptorsList.forEach((item) => {
            suscriptorsListAll += `${ item.id };`;
            suscriptorsListName += `${ item.name },`;
          });
          const suscriptorsAll = suscriptorsListAll.slice(0, -1);
          const suscriptorsData = {
            names: suscriptorsListName.slice(0, -1),
            ids: suscriptorsAll.replace(';', ','),
            codigoFlujo: 400001,
          };
          formData.suscriptorAll = suscriptorsAll;
          formData.suscriptorsData = suscriptorsData;
        }
        localStorage.removeItem('suscriptorsList');
      }

      // adding hidden fields to form data
      this.data.properties
        .filter((p) => p.type.name === 'hidden')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .filter((p) => p.fieldValue.value != null)
        .forEach((p) => {
          formData[p.alias] = p.fieldValue.value;
        });
      // adding not visible fields with submit to true to form data
      this.data.properties
        .filter((p) => String((p.config || {}).submit) === 'true' && String((p.dependency || {}).visibility) === 'false')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .filter((p) => p.fieldData.initialValue != null)
        .forEach((p) => {
          formData[p.alias] = p.fieldData.initialValue;
        });

      this.data.properties.forEach((item) => {
        const t = formData[item.alias];
        if (item?.special_values && Object.keys(item?.special_values).length > 1) {
          const { special_values: specialValue } = item;
          if (specialValue && specialValue?.integrationid && specialValue?.integrationname) {
            if (
              t
              && t[item.special_values.integrationid] === t[item.special_values.integrationname]
            ) {
              t.id = this.$refs[`field-${item.alias}`][0].fieldValue.item.id;
              t.value = this.$refs[`field-${item.alias}`][0].fieldValue.value.value;
            }
          }
        }
      });

      const attachments = this.data.properties
        .filter((p) => p.type.name === 'file')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .flatMap((fileField) => fileField.$children)
        .filter((fileComponent) => fileComponent.$vnode.componentOptions.tag === 'FileField')
        .flatMap((fileComponent) => fileComponent.files);

      this.$emit('click:submit', {
        action: submitBtn,
        data: formData,
        attachments,
      });
      this.btnDisabled = true;
      return true;
    },
    shouldUpdateUserLocation() {
      const refs = this.$refs['field-workplace'];
      if ((refs || []).length === 0) {
        return false;
      }
      const [workplaceField] = refs;
      return workplaceField.$children.length > 0
        // check into wordplace component if switch is enabled
        && workplaceField.$children[0].overrideUserWorkplace === true;
    },
    getFormDataAll() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== ''),
      );
    },
  },
  beforeDestroy() {
    this.$events.destroy(`form-${this.id}`);
  },
  created() {
    const elementForInsertLocalStorage = localStorage.getItem('elementForInsert');
    if (elementForInsertLocalStorage && elementForInsertLocalStorage.length > 0) {
      this.elementForInsert = JSON.parse(elementForInsertLocalStorage);
    } else {
      this.elementForInsert = [];
    }

    if (this.$props.profileViewForm !== true) {
      this.eventBus.on('form:disableSubmit', (disableSubmit) => {
        this.$props.submitVisible = !disableSubmit;
      });
      this.eventBus.on('form:change', (data) => {
        const dataFormAll = this.getFormDataAll();
        const dataChange = {
          dataForm: dataFormAll,
          alias: data.alias,
        };
        setTimeout(() => {
          this.$root.$emit('UpdateFiledForm', dataChange);
          this.btnDisabled = !Object.keys(dataChange.dataForm).length > 0;
        }, 1000);
        // this.$root.$emit('UpdateFiledForm', dataChange);
      });
    }
    this.$root.$on('formDisabledBtn', (data) => {
      this.btnDisabled = data;
    });
  },
};
</script>

<style lang="scss" scoped>
  .linebreak {
    height: 0;
  }
  .section--divider, .linebreak {
    flex-basis: 100%;
  }
  a {
    text-decoration: none;
  }

  @media (min-width: 960px) {
    .botonera__form {
      padding-right: 130px !important;
    }
  }
</style>
